import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {EmployeeService} from '../../services/http/employee/employee.service';
import {EmployeeDetails} from '../../classes/models/employee/EmployeeDetails';
import {DataService} from '../../services/store/data.service';
import moment from 'moment';
import {Moment} from 'moment';
import {EmployeeRoleEnum} from '../../classes/enums/EmployeeRoleEnum';
import {StoreService} from '../../services/http/store/store.service';
import {StoreDetails} from '../../classes/models/store/StoreDetails';
import {EmployeePositionId} from '../../classes/models/employee/Employee';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from '../../shared/standalone-imports';
import {ManagerSettingsComponent} from './manager-settings/manager-settings.component';
import {CapabilitiesComponent} from './capabilities/capabilities.component';
import {EmployeeRankComponent} from './employee-rank/employee-rank.component';
import {ContractHoursComponent} from './contract-hours/contract-hours.component';
import {MaximumWorkingHoursComponent} from './maximum-working-hours/maximum-working-hours.component';
import {AvailabilityComponent} from './availability/availability.component';
import {StoreNavigationComponent} from '../../shared/components/store-navigation/store-navigation.component';
import {PreferredTimeOffComponent} from "./preferred-time-off/preferred-time-off.component";

/**
 * This component handles displaying the details of an employee.
 */
@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.less'],
  imports: [
    SHARED_IMPORTS,
    ManagerSettingsComponent,
    CapabilitiesComponent,
    EmployeeRankComponent,
    ContractHoursComponent,
    MaximumWorkingHoursComponent,
    AvailabilityComponent,
    StoreNavigationComponent,
    PreferredTimeOffComponent
  ]
})
export class EmployeeDetailsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private employeeService = inject(EmployeeService);
  private storeService = inject(StoreService);
  dataService = inject(DataService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** A full data of an employee. */
  employeeDetails: EmployeeDetails;
  /** Detailed information about a store, assigned to an employee. */
  storeDetails: StoreDetails;
  /** Assigns EmployeeRoleEnum, so it can be used in HTML. */
  EmployeeRoleEnum = EmployeeRoleEnum;

  /**
   * Gets current moment.
   */
  get today(): Moment {
    return moment();
  }

  /**
   * Retrieves employee details and edit date from backend.
   */
  ngOnInit(): void {
    this.route.params
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                this.getData();
              }
            });
  }

  /**
   * Retrieves employee details and store details from backend.
   */
  getData(): void {
    const storeSlug = this.route.snapshot.paramMap.get('storeId');
    const employeeId = this.route.snapshot.paramMap.get('employeeId');
    const positionId = this.route.snapshot.paramMap.get('positionId');
    this.employeeService.getDetails(new EmployeePositionId(employeeId, positionId))
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: employeeDetails => this.employeeDetails = employeeDetails
            });
    this.storeService.getDetails(storeSlug)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: storeDetails => {
                this.storeDetails = storeDetails;
                this.dataService.editDate = storeDetails.firstEditableDate;
              }
            });
  }
}
